module.exports = require("./../../_gen/starling/core/StatsDisplay");